import React, { useState } from 'react'
import { Card, Typography } from '@telavita-core/react-design-kit'

import { ReservationExceptions } from 'components'
import { Reservation } from './components/Reservation'
import { EmptyReservation } from './components/EmptyReservation'

import { patientExceptions } from 'settings/_reservationExceptions'
import { useGetPatientReservation } from './hooks/useGetPatientReservation'

import { ReactComponent as RefreshClockSuccess } from 'static/svg/refresh-clock-success.svg'

import { ReservationRecurrence } from 'models/Reservation'

import * as S from './styles'

const SuccessFooterMessage = () => (
  <S.Footer variant='success'>
    <RefreshClockSuccess color="#4AC326" />
    <Typography variant='content2' italic>
      <b>Lembre-se</b> de agendar sempre neste dia e horário para evitar o cancelamento da reserva.
    </Typography>
  </S.Footer>
)

const ErrorFooterMessage = () => (
  <S.Footer variant='error'>
    <RefreshClockSuccess color="#FF2929"/>
    <Typography variant='content2' italic>
      Você não possui mais nenhum convênio que permita a utilização da reserva.
      <br />
      <strong>Cancele-a no menu de opções acima</strong> para voltar a agendar consultas.
    </Typography>
  </S.Footer>
)

export const ReservationCard = (): JSX.Element => {
  const [showInfoDialog, setShowInfoDialog] = useState(false)

  const { 
    reservations, 
    onRefresh,
    isFetching,
    patientPlansAllowReservation,
    patientHasNoReservationCreatedAndPlansDontAllowReservation
  } = useGetPatientReservation()
  
  if (patientHasNoReservationCreatedAndPlansDontAllowReservation || isFetching) return null
  
  const recurrenceReservation = reservations?.find(reservation => reservation.recurrence === ReservationRecurrence.WEEKLY)
  
  return (
    <S.Container>
      <Card variant='regular' customClassName='cardContainer'>
        <Typography variant='content1' weight='bolder'>
          Reserva com psicólogo
        </Typography>
      
        {!recurrenceReservation?.uuid 
          ? (
            <EmptyReservation
              infoDialog={showInfoDialog}
              setInfoDialog={setShowInfoDialog}
            />
          )
          : (
            <>
              <Reservation
                reservation={recurrenceReservation}
                onRefresh={onRefresh}
                patientPlansAllowReservation={patientPlansAllowReservation}
              />

              <ReservationExceptions 
                customClassName='exceptions'
                datesExceptions={recurrenceReservation?.recurrencyExceptions}
                textVariant='content2'
                tooltipContent={patientExceptions}
              />

              {patientPlansAllowReservation 
                ? <SuccessFooterMessage /> 
                : <ErrorFooterMessage />
              }
            </>
          )
        }
      </Card>
    </S.Container> 
  )
}
